import { Rates } from './RateGetResponse';

export interface RateArray {
  rateId: number;
  rateCategoryName: string;
  rates: Rates;
}

export interface RatePutRequest {
  ratesArray: RateArray[];
}

export const EmptyRatePutRequest: RatePutRequest = {
  ratesArray: [
    {
      rateId: 0,
      rateCategoryName: '',
      rates: {
        january: null,
        february: null,
        march: null,
        april: null,
        may: null,
        june: null,
        july: null,
        august: null,
        september: null,
        october: null,
        november: null,
        december: null,
      },
    },
  ],
};
